"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _feedbackExpressions = _interopRequireDefault(require("./feedback-expressions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  expressions: _objectSpread(_objectSpread({}, _feedbackExpressions.default), {}, {
    PRIMARY: 'Primary',
    SECONDARY: 'Secondary',
    CONTROL: 'Control',
    OPTION: 'Option',
    DISABLED: 'Disabled',
    ON_CONTRAST: 'OnContrast',
    CHOSEN: 'Chosen',
    COMPLETED: 'Completed'
  }),
  properties: {
    BACKGROUND_COLOR: 'backgroundColor',
    FOREGROUND_COLOR: 'foregroundColor',
    BORDER_COLOR: 'borderColor',
    OUTLINE_COLOR: 'outlineColor',
    SHADOW_COLOR: 'shadowColor',
    FEEDBACK_COLOR: 'feedbackColor',
    ON_FEEDBACK_COLOR: 'onFeedbackColor',
    FIGURE_COLOR: 'figureColor',
    BORDER_RADIUS: 'borderRadius',
    BORDER_WIDTH: 'borderWidth',
    FONT_FAMILY: 'fontFamily',
    FONT_SIZE: 'fontSize',
    FONT_WEIGHT: 'fontWeight',
    LINE_HEIGHT: 'lineHeight',
    TEXT_DECORATION: 'textDecoration',
    DENSITY: 'density',
    FONT_VARIATION: 'fontVariation'
  },
  interactions: {
    FOCUSED: 'Focused',
    GRABBED: 'Grabbed',
    HOVERED: 'Hovered',
    PRESSED: 'Pressed',
    CHOSEN: 'Chosen'
  },
  features: {
    BODY: 'body',
    CONTENT: 'content',
    DESCRIPTION: 'description',
    LABEL: 'label',
    METER: 'meter',
    KNOB: 'knob',
    INDICATOR: 'indicator',
    TITLE: 'title',
    ITEM: 'item',
    BACKDROP: 'backdrop'
  }
};